import React, { Component } from 'react';
import PropTypes from 'prop-types';
import MapPropTypes from '../../MapPropTypes';
import strings from '../../../strings';
import utils from '../../../utils';

export default class PriceTable extends Component {
    static propTypes = {
        pricing: PropTypes.arrayOf(MapPropTypes.PricingProps).isRequired,
    };

    _renderRows() {
        return this.props.pricing.map((item, i) => {
            return (
                <tr key={i}>
                    <th scope="row">{item.product.name}</th>
                    {item.weekly && item.weekly.length > 0 && (
                        <td key="weekly">
                            {utils.formatPrice(item.weekly[0].price)}
                        </td>
                    )}
                    {item.monthly.map(({ price }, j) => (
                        <td key={j}>{utils.formatPrice(price)}</td>
                    ))}
                </tr>
            );
        });
    }

    _renderLabels() {
        const first = this.props.pricing[0];
        const result = [];

        if (first.weekly && first.weekly.length > 0) {
            result.push(<th key="weekly">{strings.weekly}</th>);
        }

        first.monthly.forEach(({ amount }) => {
            result.push(
                <th key={amount}>
                    {amount} {strings.monthAbbr}
                </th>
            );
        });

        return result;
    }

    render() {
        if (!this.props.pricing || this.props.pricing.length <= 0) {
            return null;
        }

        return (
            <table className="table table-sm table-hover m-b-0">
                <thead className="thead-inverse">
                    <tr>
                        <th>{strings.product}</th>
                        {this._renderLabels()}
                    </tr>
                </thead>
                <tbody>{this._renderRows()}</tbody>
            </table>
        );
    }
}



// WEBPACK FOOTER //
// ./app/components/Modals/PricingModal/PriceTable.jsx